import { useMemo } from 'react';

import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';

import { groupTopicsByDate, sortChatsByDateAndFavorite } from './utils';

export const useGroupedTopics = () => {
  const { chatTopics } = useParentHelperContext();

  return useMemo(
    () => groupTopicsByDate([...chatTopics].sort(sortChatsByDateAndFavorite)),
    [chatTopics],
  );
};
